<template>
  <div>
    <v-row class="mt-4 mb-8 pl-2" align="center">
      <v-icon large>mdi-monitor</v-icon>
      <h2 class="text-h5 pl-2">Módulo Monitor de Ramais</h2>
    </v-row>
    <v-row no-gutters>
      <div class="text-h6">Geral</div>
    </v-row>
    <v-row>
      <v-col cols="6">
        <v-select
          :disabled="permissaoVisualizar || id == 1"
          dense
          v-model="selecionadoMonitorRamais"
          :items="permissionsMonitorRamais"
          label="Selecione o nível de permissão"
          outlined
          class="mt-3"
        />
      </v-col>
    </v-row>
    <!-- Seletores Gerais -->
    <v-row no-gutters class="mt-n2">
      <div class="text-h6">Ramais</div>
    </v-row>
    <v-row>
      <v-col cols="6">
        <v-autocomplete
          dense
          outlined
          label="Ramais Monitor PABX"
          v-model="selectedRamaisMonitorRamais"
          :items="ramais"
          multiple
          class="mt-2"
          :disabled="
            (selecionadoMonitorRamais !==
              dictionaryRoles.monitorCondicinado.id &&
              selecionadoMonitorRamais !==
                dictionaryRoles.monitorOuvirRamal.id) ||
              permissaoVisualizar ||
              id == 1
          "
        >
          <template v-slot:selection="{ item, index }">
            <span v-if="index === 0">{{ item.text }}</span>
            <v-chip v-if="index === 1" small>
              <span class="caption">
                (+{{ selectedRamaisMonitorRamais.length - 1 }})
              </span>
            </v-chip>
          </template>
          <template v-slot:prepend-item>
            <v-list-item ripple @click="toggleRamaisMonitor">
              <v-list-item-action>
                <v-icon
                  :color="
                    selectedRamaisMonitorRamais.length > 0
                      ? 'indigo darken-4'
                      : ''
                  "
                >
                  {{ iconRamaisMonitor }}
                </v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>
                  Selecionar Todos
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-divider class="mt-2"></v-divider>
          </template>
        </v-autocomplete>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

import { registerVuexModule } from "@/utils/vuexUtils";
import { obtainUserPermissions } from "@/utils/obtainUserPermissions";
import { addAndRemovePermissions } from "../_utils/addAndRemovePermissions";
import { dictionaryRoles } from "../_utils/dictionaryRoles";

import roleStore from "../_store";

export default {
  data: () => ({
    permissaoVisualizar: false,
    dictionaryRoles: dictionaryRoles,
    initPermissoes: false,
    // Select Ramais
    ramais: [],
    selectedRamaisMonitorRamais: [],
    initiatedRamais: false,
    // Geral
    permissionsMonitorRamais: [
      {
        text: "Sem Acesso",
        value: null,
      },
      {
        text: dictionaryRoles.monitorCondicinado.description,
        value: dictionaryRoles.monitorCondicinado.id,
      },
      // {
      //   text: dictionaryRoles.monitorOuvirRamal.description,
      //   value: dictionaryRoles.monitorOuvirRamal.id,
      // },
      {
        text: dictionaryRoles.monitorTotal.description,
        value: dictionaryRoles.monitorTotal.id,
      },
    ],
    selecionadoMonitorRamais: null,
  }),
  computed: {
    ...mapGetters("moduloPABXStepStore", [
      "getRamais",
      "getSelectedRamaisMonitorRamais",
      "getPermissoes",
    ]),

    todosRamaisMonitorSelecionados() {
      return this.selectedRamaisMonitorRamais.length === this.ramais.length;
    },
    algunsRamaisMonitorSelecionados() {
      return (
        this.selectedRamaisMonitorRamais.length > 0 &&
        !this.todosRamaisMonitorSelecionados
      );
    },
    iconRamaisMonitor() {
      if (this.todosRamaisMonitorSelecionados) return "mdi-close-box";
      if (this.algunsRamaisMonitorSelecionados) return "mdi-minus-box";
      return "mdi-checkbox-blank-outline";
    },
  },

  async created() {
    this.initPermissoes = false;
    registerVuexModule(this.$store, "moduloPABXStepStore", roleStore);

    if (this.getRamais.length === 0) {
      await this.listAllRamais();
    }

    this.ramais = this.getRamais.map((ramal) => ({
      text: ramal.numero,
      value: ramal._id,
    }));
    this.selectedRamaisMonitorRamais = this.getSelectedRamaisMonitorRamais;

    const arrayPermissions = this.arrayPermissionsFromLocalStorage();
    if (
      arrayPermissions.includes(
        process.env.VUE_APP_USUARIOS_CADASTRO_PERFIL_VISUALIZAR
      )
    ) {
      this.permissaoVisualizar = true;
    }
  },

  methods: {
    ...mapActions("moduloPABXStepStore", [
      "listAllRamais",
      "setSelectedRamaisMonitorRamais",
      "addPermissionsID",
      "deletePermissionsID",
    ]),
    ...obtainUserPermissions,
    ...addAndRemovePermissions,

    toggleRamaisMonitor() {
      this.$nextTick(() => {
        if (this.todosRamaisMonitorSelecionados) {
          this.selectedRamaisMonitorRamais.splice(0);
        } else {
          this.selectedRamaisMonitorRamais.splice(0);
          this.selectedRamaisMonitorRamais = this.ramais.map(
            (ramal) => ramal.value
          );
        }
      });
    },
  },

  watch: {
    selectedRamaisMonitorRamais: {
      deep: true,
      async handler() {
        await this.setSelectedRamaisMonitorRamais(
          this.selectedRamaisMonitorRamais
        );
      },
    },
    getSelectedRamaisMonitorRamais: {
      deep: true,
      handler() {
        if (!this.initiatedRamais) {
          this.selectedRamaisMonitorRamais = [
            ...this.getSelectedRamaisMonitorRamais,
          ];
          this.initiatedRamais = true;
        }
      },
    },

    // Monitora permissoes
    getPermissoes: {
      deep: true,
      handler(newValue) {
        if (!this.initPermissoes) {
          this.initPermissoes = true;
          // Geral
          if (newValue.includes(dictionaryRoles.monitorCondicinado.id)) {
            this.selecionadoMonitorRamais =
              dictionaryRoles.monitorCondicinado.id;
          } else if (newValue.includes(dictionaryRoles.monitorOuvirRamal.id)) {
            this.selecionadoMonitorRamais =
              dictionaryRoles.monitorOuvirRamal.id;
          } else if (newValue.includes(dictionaryRoles.monitorTotal.id)) {
            this.selecionadoMonitorRamais = dictionaryRoles.monitorTotal.id;
          }
        }
      },
    },

    //Monitora Selects
    selecionadoMonitorRamais: {
      deep: true,
      handler(newValue, oldValue) {
        this.addAndRemovePermissions(newValue, oldValue);
      },
    },
  },
};
</script>
